export const BOOKING_RULES = 'https://static.cdn-cian.ru/media/marketing/online_booking_rules.pdf';

export const GUIDE = 'https://www.cian.ru/guide/prodat-kvartiru-vtorichka/?dealType=host&offerType=apartment';

export const TG_LINK = 'https://t.me/+DaZ38m1K6Cs0MDI6';

export const MAX_LINK = 'https://l.cian.site/yj4c';

export const LINK_ICALL = 'https://support.cian.ru/ru/knowledge_base/art/7760/cat/601/';

export const ONLINE_BOOKING = 'https://promo.cian.site/online_booking';

export const REVIEW_ON_CIAN =
  'https://spb.cian.ru/stati-kak-znachok-provereno-tsian-uvelichivaet-spros-na-obekty-posutochnoj-arendy-337717/';

export const SUPERHOST = 'https://promo.cian.site/superhost';

export const ADD_ADVERTISING = 'https://www.cian.ru/razmestit-obyavlenie/';

export const LANDING_URL = 'https://www.cian.ru/ota_newhost';

export const PERSONAL_DATA = 'https://cdn.cian.site/frontend/info-assets/consents/superhost.pdf';

export const PRIVACY_POLICY = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/';

export const VK_VIDEO_LINK = 'https://l.cian.site/uxca';

export const SOCIALS_BUTTONS = [
  {
    id: 1,
    title: 'MAX',
    url: MAX_LINK,
  },
  {
    id: 2,
    title: 'Telegram',
    url: TG_LINK,
  },
];
